<form [formGroup]="form" (ngSubmit)="submit($event)">
    <app-input formControlName="actualPassword" encrypted="true" label="Contraseña actual"></app-input>
    <app-input formControlName="newPassword" encrypted="true" label="Nueva contraseña"></app-input>
    <app-input formControlName="repeatPassword" encrypted="true" label="Repetir contraseña"></app-input>


    <div class="button-container">
        <fs-ui-button  [action]="'submit'" (click)="submit($event)"  [label]="'Guardar Cambios'"></fs-ui-button>
    </div>
</form>